import { Button, Caption, H4 } from '@/components';
import CommonBlok from '@/components/common-blok';
import { LoadingImageUrl, WEB_APP_JP_SIGN_UP_URL } from '@/constants';
import React, { CSSProperties } from 'react';
import { IProblemsList, ProblemsList } from '../../constants';
import * as styles from './index.module.less';
import UsingBtn from '@/components/using-btn';

interface IProp {
  data: IProblemsList;
  gridArea: string;
}

const NUMBER_TAG = ['①', '②', '③'];
const CardHeader = ({ index, data, gridArea }: IProp & { index: number }) => {
  return (
    <div className={styles.card_header_container} style={{ gridArea }}>
      <H4 className={styles.problem_title}>
        <span>{NUMBER_TAG[index]}</span> <br />
        {data.problem}
      </H4>
    </div>
  );
};

const CardCover = ({ data, gridArea }: IProp) => {
  return (
    <div className={styles.card_cover_container} style={{ gridArea }}>
      <div className={styles.problem_with_pic}>
        <img className="lozad" src={LoadingImageUrl} data-src={data.withPicture.src} alt={data.withPicture.alt} />
      </div>
    </div>
  );
};

const CardFooter = ({ data, gridArea }: IProp) => {
  return (
    <div className={styles.card_footer_container} style={{ gridArea }}>
      <Caption>{data.solution}</Caption>
    </div>
  );
};

interface ISolveProblemsProps {
  isAdPage?: boolean;
}

const SolveProblems = ({ isAdPage = false }: ISolveProblemsProps) => {
  return (
    <CommonBlok blokBg={isAdPage ? '#fff' : '#F0F9FF'} title="お悩みをNottaで解決" isNewLayout>
      <div className={`${styles.problems_layout}`}>
        <div className={`${styles.problems_container} ${isAdPage ? styles.ad_page : ''}`}>
          {ProblemsList.map((item, index) => {
            return (
              <div
                className={`${styles.card_container} ${isAdPage ? styles.ad_page : ''}`}
                key={index}
                style={{ '--cur-column': index + 1 } as CSSProperties}
              >
                <CardHeader key={index} data={item} index={index} gridArea={'h' + (index + 1)} />
                <CardCover key={index} data={item} gridArea={'b' + (index + 1)} />
                <CardFooter key={index} data={item} gridArea={'f' + (index + 1)} />
              </div>
            );
          })}
          {/* {ProblemsList.map((item, index) => {
            return <CardHeader key={index} data={item} index={index} gridArea={'h' + (index + 1)} />;
          })}
          {ProblemsList.map((item, index) => {
            return <CardCover key={index} data={item} gridArea={'b' + (index + 1)} />;
          })}
          {ProblemsList.map((item, index) => {
            return <CardFooter key={index} data={item} gridArea={'f' + (index + 1)} />;
          })} */}
        </div>
        {isAdPage ? (
          <>
            <UsingBtn
              className={styles.ad_page_btn}
              btnWrapperClass={styles.ad_page_btn_wrapper}
              type="blackBorder"
              label="今すぐ体験する"
              link={WEB_APP_JP_SIGN_UP_URL}
            />
          </>
        ) : (
          <div className={styles.btn_container}>
            <a href={WEB_APP_JP_SIGN_UP_URL} data-gtm="home-page-notta-solve-sign-up-btn">
              <Button>無料ではじめる</Button>
            </a>
            <a href="/resources" data-gtm="home-page-notta-solve-about">
              <Button type="primary">法人向け資料</Button>
            </a>
          </div>
        )}
      </div>
    </CommonBlok>
  );
};
export default SolveProblems;
